import { Theme, SxProps } from "@mui/system";
import { useAppTheme } from "../dark-theme";

interface SxObject {
  [index: string]: SxProps;
}

export type SxObjectType = (theme: Theme) => SxObject;

export const makeSxStyles = (styles: SxObjectType): (() => SxObject) => {
  return () => {
    const theme = useAppTheme();
    return styles(theme);
  };
};
